import { PilotId } from '~/eds/src/types/PilotId';
import { DocumentHandler } from '~/features/document-handler/types/document-handler';
import { intlService } from '~/i18n/IntlService';
import { pilot } from '~/services/serviceInstances';

import { testIsAxiosError } from '../../utils';
import { DocumentServerResponse } from '../document';
import { PilotError } from '../types';
import { mapResponse } from './mapper';

interface RenameParams {
  documentId: PilotId;
  folderId: PilotId;
  name: string;
}

export const renameDocumentHandler = async ({
  documentId,
  folderId,
  name,
}: RenameParams): Promise<DocumentHandler> => {
  try {
    const response: DocumentServerResponse = await pilot.put(
      `/document/rename/${documentId}`,
      { document_name: name, folder: folderId },
    );

    return mapResponse(response);
  } catch (error: unknown) {
    if (
      testIsAxiosError<PilotError>(error) &&
      error.response?.data?.non_field_errors
    ) {
      throw new Error(error.response?.data?.non_field_errors[0]);
    }
    throw new Error(
      intlService.getIntl().formatMessage({
        id: 'renameDocumentHandler.renameError',
        defaultMessage: 'An error occurred while renaming the document',
        description: 'Error message when document renaming fails',
      }),
    );
  }
};
